export const terminalLinkGroupEditTheme = {
  enableAll: {
    bg: 'palette.surface.4',
    title: 'palette.neutral.90',
  },
};
